import { styled, FormControlLabel as FormControlLabelBase } from '@mui/material'

export const RadioFormControlLabel = styled(FormControlLabelBase)<{ error?: boolean; required?: boolean }>(
  ({ theme }) => ({
    marginLeft: 0,
    marginRight: 0,
    padding: theme.spacing(1.5, 2),

    '&:not(:first-of-type)': {
      borderTopWidth: 0.5,
      borderTopStyle: 'solid',
      borderTopColor: theme.palette.grey[300],
    },
  })
)
